// src/utils/ensureUserDoc.js
import { doc, getDoc, setDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebase';

/**
 * Гарантує, що /users/{uid} існує.
 * Створюємо ТІЛЬКИ свій документ; правилам це дозволено.
 */
export async function ensureUserDoc(user) {
  if (!user?.uid) return;

  const ref = doc(db, 'users', user.uid);
  const snap = await getDoc(ref);

  if (!snap.exists()) {
    await setDoc(ref, {
      uid: user.uid,
      email: user.email ?? null,
      displayName: user.displayName ?? '',
      phone: '',
      photoURL: user.photoURL ?? null,
      role: 'user',                     // дефолтна роль
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp(),
    });
  } else {
    // можна оновити службове поле updatedAt
    await setDoc(
      ref,
      { updatedAt: serverTimestamp() },
      { merge: true }
    );
  }
}
